export const MULTI_SKU_MODAL = 'sailorc://keeta.com/machproalert?bundle_name=mach_pro_sailor_c_shop_multi_sku_modal';
export const SHOP_PAGE = 'sailorc://keeta.com/machpro?mach_bundle_name=mach_pro_sailor_c_shop';

export const HomePageCid = 'c_waimai_c_overseas_aatucy3n';

export const HomePageFooterBarMv = 'b_sailor_c_66p1m4aj_mv';

export const HomePageFooterBarMc = 'b_sailor_c_66p1m4aj_mc';

export const HomePageFooterBarCloseMc = 'b_sailor_c_jvddatt9_mc';

export const CarouselItemMc = 'b_sailor_c_911k0mcp_mc';
export const CarouselItemMv = 'b_sailor_c_911k0mcp_mv';
export const CarouselOtherMc = 'b_sailor_c_ffsyi4kg_mc';

export const RightOverlayMc = 'b_sailor_c_0uykskvf_mc';

export const RightOverlayMv = 'b_sailor_c_0uykskvf_mv';

export const EVENT_NAME = {
  ONSCROLL: 'onScroll',
  ONSCROLLEND: 'onScrollEnd',
  CELLAPPEARPREFIX: 'onCellAppear_', // 卡片出现前缀
  SCROLL_TO_TOP: 'Scroll_to_top',
};

export const SCROLL_TYPE = {
  STICKY: 'sticky',
  NORMAL: 'normal',

};
